export default Object.freeze({
  new: 1,
  submitted: 2,
  completed: 3,
  related: 4
});
